import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from '../services/api.service';
import { TranslateService } from '../services/translate.service';

@Component({
  selector: 'app-payslips',
  templateUrl: './payslips.component.html',
  styleUrls: ['./payslips.component.scss']
})
export class PayslipsComponent implements OnInit {

  employees: any[] = [];
  selectedEmpId: number | null = null;
  selectedMonthYear: string = '';

  payslip: any = null;
  isLoading = false;
  employeeSearch: string = '';

  constructor(
    private apiService: ApiService,
    private snackBar: MatSnackBar,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.loadEmployees();
  }

  loadEmployees(): void {
    this.apiService.getEmplyees().subscribe(res => {
      const data: any = res || {};
      this.employees = data.employees || [];
    });
  }

  get filteredEmployees(): any[] {
    const term = (this.employeeSearch || '').toLowerCase().trim();
    if (!term) {
      return this.employees;
    }
    return this.employees.filter(e => {
      const id = e.employeeId != null ? String(e.employeeId) : '';
      const name = (e.employeeName || e.name || '').toLowerCase();
      return id.includes(term) || name.includes(term);
    });
  }

  viewPayslip(): void {
    if (!this.selectedEmpId || !this.selectedMonthYear) {
      this.snackBar.open(this.translate.t('SELECT_EMPLOYEE_AND_MONTH'), 'Close', { duration: 3000 });
      return;
    }
    this.isLoading = true;
    this.apiService.getPayslip(this.selectedEmpId, this.selectedMonthYear).subscribe(
      data => {
        this.payslip = data;
        this.isLoading = false;
      },
      err => {
        this.isLoading = false;
        const msg = err?.error?.message || this.translate.t('FAILED_LOAD_PAYSLIP');
        this.snackBar.open(msg, 'Close', { duration: 4000 });
      }
    );
  }

  downloadPdf(): void {
    if (!this.selectedEmpId || !this.selectedMonthYear) {
      this.snackBar.open(this.translate.t('SELECT_EMPLOYEE_AND_MONTH'), 'Close', { duration: 3000 });
      return;
    }
    const url = this.apiService.getPayslipPdfUrl(this.selectedEmpId, this.selectedMonthYear);
    window.open(url, '_blank');
  }
}
